module.exports = __webpack_public_path__ + "static/terra-b46b690487f30c0587eddd7b00d78bef.png";